import { RouterProvider } from 'atomic-router-react'
import { Pages } from '@/pages'
import { router } from './routing/router'
import { Styles } from './styles'
import { useUnit } from 'effector-react'
import { ThemeProvider } from '@mui/material'
import { useEffect } from 'react'
import ReactGA from 'react-ga4'
import { gtag } from '@/shared/constants'
import { AppContainer } from './container'
import { MuiTheme } from '@/shared/styles/mui'
import { $isAppUpdating } from '@/entities/integration/model/store'
import { goToUpdating } from './routing/events'

// const keysToInvalidate = [
//   'currencyRates',
//   'subscriptionPrices',
//   'tasksList',
//   'totalAccountValue',
//   'hoursLeaderboard',
//   'assetsLeaderboard',
//   'gigiLeaderboard',
//   'gamedLeaderboard',
// ]

export const App = () => {
  const path = useUnit(router.$path)
  const isAppUpdating = useUnit($isAppUpdating)
  ReactGA.initialize(gtag)

  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: window.location.pathname })
  }, [path])

  useEffect(() => {
    if (isAppUpdating) {
      return goToUpdating()
    }
  }, [isAppUpdating, path])

  return (
    <RouterProvider router={router}>
      <ThemeProvider theme={MuiTheme}>
        <Styles>
          <AppContainer>
            <Pages />
          </AppContainer>
        </Styles>
      </ThemeProvider>
    </RouterProvider>
  )
}
